import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Recuerdo from "../../../images/modulo14/recuerdojose.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[7];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[8].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[8].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[6].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[6].path}`,
  };

  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Observa esta viñeta:</li>
      </ul>
      <div className="row align-items-center my-5 px-4">
        <div className="col-lg-10 col-12">
          <img src={Recuerdo} className="bg-white img-fluid" alt="Recuerdo" />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Conversa sobre lo siguiente con un compañero, compañera o
              familiar: ¿qué decisión ha tomado el papá de José?, ¿por qué crees
              que ha tomado esa decisión?
            </li>
          </ul>
          <textarea rows={3} className="form-control" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa esta viñeta. Pida a sus que lean la viñeta donde José está
            recordando una conversación que tuvieron sus padres cuando era niño.
            Lea la segunda indicación: Conversa sobre lo siguiente con un
            compañero o compañera o familiar: ¿qué decisión ha tomado el papá de
            José?, ¿por qué crees que ha tomado esa decisión? Retome las
            respuestas:
            <ul>
              <li>
                <i>
                  “¿Qué decisión ha tomado el papá de José? (Posible respuesta:
                  Al papá de José le parece que él y su esposa deben dejar de
                  hablar en aimara y comenzar a hablar solo en castellano.)
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué crees que ha tomado esa decisión? (Posible respuesta:
                  Porque José va a entrar a la escuela donde seguramente solo
                  hablan en castellano).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
